import { Link, useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import LogoutIcon from "@mui/icons-material/Logout";

import LogoImg from "src/assets/Images/logo-img.png";

import { PATH_AUTH, PATH_DASHBOARD } from "src/routes/paths";
import { YellowLogo } from "src/components/Logo.jsx";
import MainFooter from "src/layouts/Footer";
import useAuth from "src/hooks/useAuth";
import { ToolbarShadowStyle, ToolbarStyle } from "src/layouts/appbar";
import useOffSetTop from "src/hooks/useOffSetTop";
import { AHidden } from "src/components/@material-extend";

const StyledLink = styled(Typography)(({ theme }) => ({
  mr: 2,
  display: { xs: "none", md: "flex" },
  fontWeight: 700,
  color: "white",
  textDecoration: "none",
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

export default function LandingPageLayout({ children }) {
  const isOffset = useOffSetTop(10);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <>
      <AppBar
        sx={{
          boxShadow: 0,
          backgroundImage: "none",
          bgcolor: "transparent",
        }}
      >
        <ToolbarStyle
          disableGutters
          sx={{
            px: { xs: 0, md: 2 },
            ...(isOffset && {
              bgcolor: "background.default",
              // height: { md: APP_BAR_DESKTOP - 16 },
            }),
          }}
        >
          <Container
            maxWidth="xxl"
            sx={{ py: 2, display: "flex", alignItems: "center" }}
          >
            <AHidden width="mdDown">
              <Box
                src={LogoImg}
                component="img"
                sx={{
                  mr: 1,
                  width: 180,
                  height: 60,
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(PATH_DASHBOARD.home);
                }}
              />
            </AHidden>
            <AHidden width="mdUp">
              <YellowLogo />
            </AHidden>

            <Box flexGrow={1} />

            {!isAuthenticated ? (
              <StyledLink
                noWrap
                variant="h6"
                component={Link}
                to={PATH_AUTH.login}
              >
                Login
              </StyledLink>
            ) : (
              <Stack direction="row" spacing={1} alignItems="center">
                <StyledLink
                  noWrap
                  variant="h6"
                  component={Link}
                  to={PATH_DASHBOARD.account}
                >
                  Welcome back {user.userName}
                </StyledLink>
                <AHidden width="mdUp">
                  <IconButton>
                    <LogoutIcon sx={{ color: "text.primary" }} />
                  </IconButton>
                </AHidden>
                <AHidden width="mdDown">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      logout();
                    }}
                  >
                    Logout
                  </Button>
                </AHidden>
              </Stack>
            )}
          </Container>
        </ToolbarStyle>
        {isOffset && <ToolbarShadowStyle />}
      </AppBar>
      {children}
      <MainFooter />
    </>
  );
}
